/**
 * 双人空间相关 API（docs/rbac.md §5.2 / §5.3）。
 *
 * 路径全部走 `apiPaths.spaces.*`（src/shared/api/paths.ts），
 * 本文件不允许再出现裸的 API v1 字面量。
 *
 * 关键 CRUD（POST/PATCH/PUT/DELETE）路径已挂上 `trackOperation` 用户操作埋点；
 * 只读 GET 接口按方案跳过。
 */

import { ApiError, client } from '../../../shared/api/client';
import { apiPaths } from '../../../shared/api/paths';
import type { MemberView, SpaceRoleResp, SpaceView } from '../../../shared/api/types';
import { trackOperation } from '../../../shared/telemetry/operationLog';

function trackFromError(action: string, resource: string, err: unknown): void {
  trackOperation({
    action,
    resource,
    result: 'failure',
    errorCode: err instanceof ApiError ? err.code : 'UNKNOWN',
  });
}

export const spaceApi = {
  getCurrent: (): Promise<SpaceView> => client.get<SpaceView>(apiPaths.spaces.current),

  leave: async (): Promise<void> => {
    try {
      await client.post<void>(apiPaths.spaces.leave);
      trackOperation({ action: 'space.leave', resource: 'space', result: 'success' });
    } catch (err) {
      trackFromError('space.leave', 'space', err);
      throw err;
    }
  },

  getMembers: (): Promise<MemberView[]> => client.get<MemberView[]>(apiPaths.spaces.members),

  getRole: (): Promise<SpaceRoleResp> => client.get<SpaceRoleResp>(apiPaths.spaces.role),
};
